module.exports = __webpack_public_path__ + "img/ArmadilloComputer.748fd1b6.svg";